
import { Poker2SoundController } from "../../../controller/Poker2SoundController";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2TourResultDialogProperties } from "./Poker2TourResultDialogProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

/**
 * Displays tournament result for the first rank.
 *
 * @author Patrick
 */
export class Poker2TourResult1Dialog extends Poker2Dialog {
    public static NAME: string = "Poker2TourResult1Dialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected applyProperties(): void {
        this.resultDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        this.resultDialog.txt_rank.text = String(this.resultDialogProperties.tournamentResultVO.rank);
        this.resultDialog.txt_rank_title.text = Poker2Model.languageData.getTextById("dialog_tournament_subtitle");
        //
        this.resultDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_tournament_victory_titel");
        this.resultDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_tournament_victory_copy");
        //
        this.resultDialog.txt_chips.text = NumberStringHelper.groupString(this.resultDialogProperties.tournamentResultVO.chips, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.resultDialog.txt_gold.text = NumberStringHelper.groupString(this.resultDialogProperties.tournamentResultVO.gold, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.resultDialog.txt_tp.text = NumberStringHelper.groupString(this.resultDialogProperties.tournamentResultVO.tournamentPoints, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));

        this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_WIN);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.resultDialog.btn_ok:
                this.hide();
                if (this.resultDialogProperties.functionOk != null)
                    this.resultDialogProperties.functionOk();
                break;
        }
    }

    protected get resultDialogProperties(): Poker2TourResultDialogProperties {
        return this.properties as Poker2TourResultDialogProperties;
    }

    protected get resultDialog(): Library.PokerPopUps.PokerTourResult1a {
        return this.disp as Library.PokerPopUps.PokerTourResult1a;
    }
}
